module.exports = __webpack_public_path__ + "img/to-top-button.3a5b895d.png";